import { render, staticRenderFns } from "./AttrGalleryNewForm.vue?vue&type=template&id=62499650&"
import script from "./AttrGalleryNewForm.vue?vue&type=script&lang=js&"
export * from "./AttrGalleryNewForm.vue?vue&type=script&lang=js&"
import style0 from "./AttrGalleryNewForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports